import React, { Component } from "react";

class Buscador extends Component {
  busquedaRef = React.createRef(); //Permite leer el INPUT REFRENCIADO

  obtenerDatos = (e) => {
    //'e' sería el evento que toma
    e.preventDefault();

    //Tomamos el vlaor del imput y lo enviamos al componente principal
    const termino = this.busquedaRef.current.value;

    this.props.datosBusqueda(termino);
  };

  render() {
    return (
      <form onSubmit={this.obtenerDatos}>
        <div className="row">
          {/*TextBox para buscar */}
          <div className="form-group col-md-8">
            <input
              ref={this.busquedaRef} //INPUT REFRENCIADO
              type="text"
              className="form-control form-control-lg"
              placeholder="Qué quieres ver?  Ej. Gatos"
            />
          </div>

          {/* Boton buscar */}
          <div className="form-group col-md-4">
            <input
              type="submit"
              className="btn btn-lg btn-outline-danger btn-block"
              value="Buscar"
            />
          </div>
        </div>
      </form>
    );
  }
}

export default Buscador;
